import { render, staticRenderFns } from "./VehicleAltPolicy.vue?vue&type=template&id=3731d78f&scoped=true&"
import script from "./VehicleAltPolicy.vue?vue&type=script&lang=js&"
export * from "./VehicleAltPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3731d78f",
  null
  
)

export default component.exports